//export const SERVER_URL = "http://localhost:5016";
export const SERVER_URL = "https://vocbackend.cmxph.com";
